// src/theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  // Your custom theme settings here
});

export default theme;